import React from 'react';
import classNames from 'classnames';
import LazyLoad from 'react-lazy-load';
import headingStyles from '../components/Brand/Heading/Heading-tw-styles';
import quotesTextStyles from '../components/Brand/Quotes/QuotesTextStyles-tw-styles';
import richTextStyles from '../components/Brand/Richtext/Richtext-tw-styles';
import buttonStyles from '../components/Brand/Button/Button-tw-styles';
import { ParallaxImage } from '../components/Brand/BackgroundImage';
import getWidth from './gridWidth';
import { getCdnImage as getImageUrl } from './ImageManager';
import getCdnSrcset from './srcSetHelper';
import Product from '../components/Brand/Product';
import ContentCard from '../components/Brand/ContentCard';
import VideoBanner from '../components/Brand/VideoBanner/VideoBanner';
import StoryCard from '../components/Brand/StoryCard';
import BrandCarousel from '../components/Brand/Carousel';
import { VideoCard } from '../components/Brand/VideoCard';
import HomepageCarousel from '../components/Brand/HomepageCarousel/HomepageCarousel';
import Typography from '../components/Generic/Typography';
import { Button } from '../components/Generic/Button';
import { Banner } from '../components/Brand/Banner';
import { HorizontalCard, JumboCard } from '../components/Brand/Card';
import { StackedCard } from '../components/Brand/Card';
import SectionContainer from '../components/Brand/SectionContainer';
import DOMPurify from 'isomorphic-dompurify';
import { navigationHeaders } from '../constants/global';
import HomeBanner from '../components/Brand/Banner/HomeBanner';

let collectionCardCounter = 0;

export const resetCollectionCardCounter = () => {
  collectionCardCounter = 0;
};

export const getCard = (card, lazy, section = null) => {
  switch (card.variant) {
    case 'Stacked':
      return (
        section.styles === 'IngredientsSection' ? (
          <StackedCard
            key={card.sys.id}
            data={card}
            detachBuyNowDialog={card.detachBNL}
            buyNowClickHandler={card.onClick}
            pictureLazyLoad={false}
          />
        ) : (
         lazy ?  <StackedCard
         key={card.sys.id}
         data={card}
         detachBuyNowDialog={card.detachBNL}
         buyNowClickHandler={card.onClick}
       /> : 
        <LazyLoad offset={-30}>
          <>
          <StackedCard
            key={card.sys.id}
            data={card}
            detachBuyNowDialog={card.detachBNL}
            buyNowClickHandler={card.onClick}
          />
          </>
        </LazyLoad>
        )
      );
    case 'Jumbo':
      return (
        <JumboCard
          key={card.sys.id}
          data={card}
        />
      );
    case 'Horizontal':
      return card.styles === 'um-cabelo-card' ? (
        <HorizontalCard key={card.sys.id} data={card} />
      ) : (
        lazy ? <HorizontalCard key={card.sys.id} data={card} />
        :
        <LazyLoad offset={-30}>
          <>
        <HorizontalCard key={card.sys.id} data={card} />
          </>
        </LazyLoad>
      )
    case 'Series-Feature':
      return null;
    case 'Prodfeature':
      return null;
    case 'Series':
      return null;
    case 'Editorial':
      return null;
    case 'Listing-Card':
      return <Product data={card} />;
    default:
      return null;
  }
};

export const getBanner = (banner, index = null) => {
  if (banner.styles === 'banner-disclaimer-badge') {
    return null;
  }
  if (
    (index === 3 || index === 4) &&
    (banner.styles === 'home-banner-text-right-sticky' || banner.styles === 'home-banner-text-reverse')
  ) {
    return <LazyLoad offset={-20}><><Banner key={banner.sys.id} {...banner} /></></LazyLoad>
  }
  if (banner.styles === 'ManifestosecondCardSection') {
    return <LazyLoad offset={-20}><><Banner key={banner.sys.id} {...banner} /></></LazyLoad>
  }
  return <Banner key={banner.sys.id} {...banner} />;
};

export const getCarousel = carousel => {
  return <BrandCarousel key={carousel.sys?.id} carousel={carousel} />;
};

export const getHomepageCarousel = carousel => {
  return <HomepageCarousel key={carousel.sys?.id} carousel={carousel} />
};

export const getContentfulLink = contentLink => {
  const id =
    contentLink.linksCollection !== null
      ? contentLink.linksCollection.items[0].sys.id
      : '0';
  return null;
};

// Change Name of this function
export const getImage = (image, lazy) => {
  const widthClass = getWidth(image.componentWidth);
  let src = '';
  if (image.image && image.image.url) {
    src = getImageUrl(image.image.url);
  }
  if (src) {
    return (
      lazy ?
        <img
          key={image.sys.id}
          src={src}
          alt={image.altText}
          className={classNames(widthClass, image.styles)}
        /> :
        <LazyLoad offset={-20}>
        <>
          <img
            key={image.sys.id}
            src={src}
            alt={image.altText}
            className={classNames(widthClass, image.styles)}
          />
          </>
        </LazyLoad>
    );
  }
  return null;
};

export const getButtonVariant = (buttonVariant, buttonStyle) => {
  switch (buttonVariant.variant) {
    case 'Shopnow':
      return null;
    default:
      if (buttonVariant.name == navigationHeaders.SOBRE_NOS || buttonVariant.name == navigationHeaders.NOVIDADES) {
        return (
          <h4 className="footerHeader text-16 font-BebasNeueBold no-underline cursor-auto footer-heading-style">
            {buttonVariant.linkText}
          </h4>
        )
      } else {
        return (
          <Button
            to={buttonVariant.link}
            className={buttonStyle}
            key={buttonVariant.sys.id}
            title={buttonVariant.tooltip}
            target={buttonVariant.target}
          >
            {buttonVariant.linkText}
          </Button>)
      }
  }
};
export const getButton = button => {
  const widthClass = getWidth(button.componentWidth);
  let buttonStyle = '';
  if (button.styles && buttonStyles[button.styles.trim()] !== undefined) {
    buttonStyle = buttonStyles[button.styles.trim()];
  }
  if (button.linkText == 'Bambu Nutre e Cresce' ||
    button.linkText == "Unidas Pelos Cachos " ||
    button.linkText == "Nova Fórmula" ||
    button.linkText == "Queratina Preenche & Blinda" ||
    button.linkText == "Nossa História " ||
    button.linkText == "Nosso Manifesto" ||
    button.linkText == "Segurança e Qualidade" ||
    button.linkText == "Recicle ou reutilize" ||
    button.linkText == "Pantene Queratina Óleo & Spray" ||
    button.linkText == "Economize água na rotina capilar") {
    return (
      <div key={button.sys.id} className="list_style_item">
        <Button
          to={button.link}
          className={buttonStyle}
          title={button.tooltip}
          target={button.target}
        >
          {button.linkText}
        </Button>
      </div>
    )
  }
  else {
    return (<div key={button.sys.id} className={classNames(widthClass)}>
      {getButtonVariant(button, classNames(buttonStyle, button.gaEventClass))}
    </div>
    );
  }
};
export const getImageButton = imagebutton => {
  let src = '';
  if (imagebutton.image) {
    src = getImageUrl(imagebutton.image && imagebutton.image.url);
  }
  if (src) {
    const widthClass = getWidth(imagebutton.componentWidth);
    return (
      <Button
        key={imagebutton.sys.id}
        to={imagebutton.link}
        title={imagebutton.tooltip}
        className={classNames(
          widthClass,
          imagebutton.styles,
          imagebutton.gaEventClass
        )}
        target={imagebutton.target}>
        <LazyLoad offset={-20}>
          <>
            <img
              src={src}
              alt={imagebutton.altText}
              className={classNames(
                widthClass,
                imagebutton.styles,
                imagebutton.gaEventClass
              )}
            />
          </>
        </LazyLoad>
      </Button>
    );
  }
  return null;
};

export const getBannerImageButton = bannerimagebutton => {
  let src = '';
  if (bannerimagebutton.image) {
    src = getImageUrl(bannerimagebutton.image && bannerimagebutton.image.url);
  }
  if (src) {
    return (
      <Button
        key={bannerimagebutton.sys.id}
        href={bannerimagebutton.link}
        title={bannerimagebutton.tooltip}
        className={classNames(
          bannerimagebutton.styles,
          bannerimagebutton.gaEventClass
        )}
        target={bannerimagebutton.target}>
        <img
          src={src}
          alt={bannerimagebutton.altText}
          className={classNames(
            bannerimagebutton.styles,
            bannerimagebutton.gaEventClass
          )}
        />
      </Button>
    );
  }
  return null;
};
export const getContentImageSet = (imageset,section) => {
    if (imageset) {
    const widthClass = getWidth(imageset.componentWidth);

      return (
        section?.styles === "JamieBannerSectionLink" ? (
          <a href={"/pt-br/produtos/tratamentos/serum-pantene-forca-nutricao"}>
            <picture>
              <source
                srcSet={imageset.desktopImage && imageset.desktopImage.url}
                media="(min-width: 1024px)"
              />
             <img 
                 className={classNames(widthClass, imageset.styles)}
                 loading={"auto"}
                 src={imageset.smartphoneImage && imageset.smartphoneImage.url}
                 alt={imageset.altText}
             />
        </picture>
        </a>
      ) :
      (
          <picture>
            <source
              srcSet={imageset.desktopImage && imageset.desktopImage.url}
              media="(min-width: 1024px)"
            />
             <img 
                 className={classNames(widthClass, imageset.styles)}
                 loading={"auto"}
                 tabindex="0"
                 src={imageset.smartphoneImage && imageset.smartphoneImage.url}
                 alt={imageset.altText}
                 aria-label={imageset?.ariaLabel || ""}
             />
        </picture>
      ))

    }
  return null;
};
export const getImageSet = imageset => {
  if (imageset) {
    const widthClass = getWidth(imageset.componentWidth);
    return (
      <div
        key={imageset.sys.id}
        className={classNames(widthClass, imageset.styles)}
      >
          <>
            <picture>
              <source
                src={getImageUrl(
                  imageset.desktopImage && imageset.desktopImage.url,
                  { w: 1600 }
                )}
                srcSet={getCdnSrcset(
                  imageset.desktopImage && imageset.desktopImage.url,
                  1600,
                  768
                )}
                media="(min-width: 768px)"
              />
              <img
                className={classNames(widthClass, imageset.styles)}
                src={getImageUrl(
                  imageset.smartphoneImage && imageset.smartphoneImage.url,
                  750
                )}
                alt={imageset.altText}
              />
            </picture>
          </>
      </div>
    );
  }
  return null;
};

export const getRichText = (richtext, section, sectionIndex) => {
  const widthClass = getWidth(richtext.componentWidth);
  let richtextStyle = '';
  if (richtext?.styles && richTextStyles[richtext?.styles?.trim()] !== undefined) {
    richtextStyle = richTextStyles[richtext?.styles?.trim()];
  }
  const isArticleDetail = (section?.styles === 'article-detail-section-container' && sectionIndex >= 3) || (section?.styles === 'longformtextstripe' && sectionIndex >= 1)
  return (
    isArticleDetail ? (
      <LazyLoad offset={-20}>
        <>
          <Typography
            key={richtext.sys.id}
            className={classNames(widthClass, richtextStyle)}
            component="div"
            dangerouslySetInnerHTML={
              richtext.body && {
                __html: DOMPurify.sanitize(richtext.body, { ADD_TAGS: ["iframe"], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'onload'] })
              }
            }
          />
        </>
      </LazyLoad>
    ) : (
      <Typography
        key={richtext.sys.id}
        className={classNames(widthClass, richtextStyle)}
        component="div"
        dangerouslySetInnerHTML={
          richtext.body && {
            __html: DOMPurify.sanitize(richtext.body, { ADD_TAGS: ["iframe"], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'onload'] })
          }
        }
      />
    )
  );
};

export const getHeading = (heading, id, classes) => {
  let headingStyle = '';
  if (heading?.styles && headingStyles[heading?.styles?.trim()] !== undefined) {
    headingStyle = headingStyles[heading?.styles?.trim()];
  }
  const widthClass = getWidth(heading.componentWidth);
  return (
    <Typography
      id={id}
      key={heading && heading.sys && heading.sys.id}
      className={classNames(widthClass, headingStyle, classes)}
      component={
        heading.headingName ? heading.headingName.toLowerCase() : 'div'
      }
      dangerouslySetInnerHTML={
        heading.heading && {
          __html: DOMPurify.sanitize(heading.heading, { ADD_TAGS: ["iframe"], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'onload'] })
        }
      }
    />
  );
};
export const getQuoteText = quoteText => {
  let quotesStyle = '';
  if (
    quoteText.styles &&
    quotesTextStyles[quoteText.styles.trim()] !== undefined
  ) {
    quotesStyle = quotesTextStyles[quoteText.styles.trim()];
  }
  return (
    <Typography
      key={quoteText.sys.id}
      className={classNames(quotesStyle)}
      component="div"
      dangerouslySetInnerHTML={
        quoteText.text && {
          __html: DOMPurify.sanitize(quoteText.text, { ADD_TAGS: ["iframe"], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'onload'] })
        }
      }
    />
  );
};
export const getContentCard = (content, pageContext, section, index = 0) => {
  let contentData = content;
  
  if (section.styles === 'collection-card') {
    const globalIndex = collectionCardCounter;
    collectionCardCounter++;
    const alternatingStyles = globalIndex % 2 === 0 ? 'content-page-text-left' : 'content-page-text-right';
    contentData = {
      ...content,
      styles: alternatingStyles
    };
  }
  
  if (section.styles === 'collection-card' && content.__typename === 'ContentCard') {
    return (
      <LazyLoad offset={-20}>
        <>
          <ContentCard data={contentData} pageContext={pageContext} />
        </>
      </LazyLoad>
    )
  } else
    return <ContentCard data={contentData} pageContext={pageContext} />;
};
export const getHomeBanner = content => {
  return <HomeBanner data={content} />;
};
export const getStoryCard = content => {
  return <StoryCard data={content} />;
};
export const getParallax = backgroundImage => {
  return <ParallaxImage backgroundImage={backgroundImage} />;
};
export const getVideoCard = (videoCard, heroImage) => {

  if (videoCard.styles === 'campaignSubVideoCard') {
    return <LazyLoad offset={-20}>
      <>
        <VideoCard key={videoCard.sys.id} data={videoCard} heroImage={heroImage} />
      </>
    </LazyLoad>
  } else
    return <VideoCard key={videoCard.sys.id} data={videoCard} heroImage={heroImage} />;
};
export const getVideoBanner = videoBannerData => {
  return <VideoBanner key={videoBannerData.sys.id} data={videoBannerData} />;
};

export const renderSection = (section, pageContext, lazy, index = null) => {
  const sectionBackground = section.backgroundImage
    ? {
      // backgroundImage: `url("${section.backgroundImage &&
      //   section.backgroundImage.url}")`,
      backgroundColor: `white`,
    }
    : {};

  return (
    <SectionContainer
      key={section.sys.id}
      styles={section.styles}
      domId={section.domId}
      width={section.componentWidth}
      background={sectionBackground}
      ariaLabel={section.ariaLabel}
    >
      {section.sectionContentCollection &&
        section.sectionContentCollection.items.map((content, sectionIndex) => {
          if (content) {
            switch (content.__typename) {
              case 'Callout':
                return getCard(content, section, lazy);
              case 'LinkContainer':
                return getContentfulLink(content);
              case 'Banner':
                return getBanner(content, index);
              case 'Carouselcontainer':
                return getCarousel(content);
              case 'Image':
                return getImage(content, lazy);
              case 'ImageSet':
                if(section.styles === 'JamieBannerSection' || section.styles === "JamieBannerSectionLink") {
                  return getContentImageSet(content,section);
                }
                else {
                  return getImageSet(content);
                }
              case 'LinkButton':
                return getButton(content);
              case 'HomeBanner':
                return getHomeBanner(content);
              case 'ContentTypeRichText':
                return getRichText(content, section, sectionIndex);
              case 'HeadingTypes':
                return getHeading(content);
              case 'ImageButton':
                return getImageButton(content);
              case 'QuotesText':
                return getQuoteText(content);
              case 'ContentCard':
                return getContentCard(content, pageContext, section, sectionIndex);
              case 'StoryCard':
                return getStoryCard(content);
              case 'BackgroundImage':
                return getParallax(content);
              case 'VideoCard':
                return getVideoCard(content);
              case 'VideoBanner':
                return getVideoBanner(content);
              case 'SectionContainer':
                return renderSection(content);
              default:
                return null;
            }
          }
        })}
    </SectionContainer>
  );
};